module.exports = __webpack_public_path__ + "img/css.39df94ae.png";